import { render } from "./week-setting.vue?vue&type=template&id=3d783c64&scoped=true"
import script from "./week-setting.vue?vue&type=script&lang=js"
export * from "./week-setting.vue?vue&type=script&lang=js"

import "./week-setting.vue?vue&type=style&index=0&id=3d783c64&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d783c64"]])

export default __exports__